import React from 'react';
import type { Rule } from 'antd/es/form';
import type { NamePath } from 'antd/es/form/interface';
import { useIntl } from 'react-intl';

import { FormFloatingCurrencyItem } from '../form-floating-currency-item';

import styles from './styles.module.scss';

export interface ChargeSummaryAmountFieldProps {
  name: NamePath;
  rules: Rule[];
  dependencies?: NamePath[];
  validateTrigger?: string | string[];
  formItemClassName: string;
  ariaLabel: string;
  /** Upper bound for step buttons; should match validation (same total used on blur clamp). */
  stepMax?: number;
  stepMin?: number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
}

export function ChargeSummaryAmountField({
  name,
  rules,
  dependencies,
  validateTrigger = ['onBlur', 'onChange'],
  formItemClassName,
  ariaLabel,
  stepMax,
  stepMin,
  onChange,
  onBlur,
}: ChargeSummaryAmountFieldProps): React.ReactElement {
  const intl = useIntl();
  const itemClass = [formItemClassName, styles.amountFormItem].filter(Boolean).join(' ').trim();

  return (
    <FormFloatingCurrencyItem
      name={name}
      label={intl.formatMessage({ id: 'certificates.payment.chargeSummary' })}
      rules={rules}
      dependencies={dependencies}
      validateTrigger={validateTrigger}
      formItemClassName={itemClass}
      placeholder={intl.formatMessage({ id: 'certificates.payment.amountPlaceholder' })}
      inputMode="decimal"
      aria-label={ariaLabel}
      stepMax={stepMax}
      stepMin={stepMin}
      onChange={onChange}
      onBlur={onBlur}
    />
  );
}
